export default "/assets/images/peacekeeper-3.png?ef86914e1ed8afb0af06c6b9fbabdd3a";